import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b6a33e32"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "topNav"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-31liebiao"
})])], -1));
const _hoisted_3 = {
  class: "topContent"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "active"
}, "发现", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "云村", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "视频", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-sousuo"
}, null, -1));
const _hoisted_8 = [_hoisted_7];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push('/userinfo'))
  }, "我的"), _hoisted_4, _hoisted_5, _hoisted_6]), _createElementVNode("div", null, [(_openBlock(), _createElementBlock("svg", {
    class: "icon",
    "aria-hidden": "true",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.push('/search'))
  }, _hoisted_8))])]);
}